<template>
  <nav>
    <ul>
      <li v-for="i in total" :key="i">
        <button
          type="button"
          :disabled="index === i - 1"
          :class="{ disabled: index === i - 1 }"
          @click="() => handleSelectDot(i - 1)"
        />
      </li>
    </ul>
  </nav>
</template>
<script setup lang="ts">
interface Props {
  total: number;
  index: number;
}

defineProps({
  total: null,
  index: null
});
const emit = defineEmits(["select"]);
const handleSelectDot = (index) => {
  emit('select', index);
};
</script>
<style lang="scss" scoped>
ul {
  display: flex;
  justify-content: center;
}

button {
  position: relative;
  width: 2rem;
  height: 2rem;
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1rem;
    height: 1rem;
    margin-top: -0.5rem;
    margin-left: -0.5rem;
    border-radius: 50%;
    background-color: var(--color_secondary_light);
  }
  &::after {
    transform: scale(0);
    transition: transform 300ms $ease-out-quad;
    background-color: var(--color_secondary);
  }

  &.disabled {
    &::after {
      transform: scale(1);
      transition: transform 300ms $ease-in-quad;
    }
  }
}
</style>
